import { render } from "./TheThanhTichHSG.vue?vue&type=template&id=6a57f340"
import script from "./TheThanhTichHSG.vue?vue&type=script&lang=js"
export * from "./TheThanhTichHSG.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__